import React from 'react';

const BrandedHeader = ({ children, className = "" }) => {
  return (
    <header className={`border-b border-border bg-card/50 backdrop-blur-sm ${className}`}>
      <div className="flex items-center justify-between px-4 py-3">
        {/* Securado Logo - Left (White version for dark theme) */}
        <div className="flex-shrink-0">
          <img 
            src="/branding/securado-logo-white.png" 
            alt="Securado" 
            className="h-10 w-auto object-contain"
          />
        </div>
        
        {/* Center Content */}
        <div className="flex-1 flex items-center justify-center px-4">
          {children}
        </div>
        
        {/* Digital Vaccine Logo - Right (White reverse version for dark theme) */}
        <div className="flex-shrink-0">
          <img 
            src="/branding/digital-vaccine-logo-white.png" 
            alt="The Digital Vaccine" 
            className="h-14 w-auto object-contain"
          />
        </div>
      </div>
    </header>
  );
};

export default BrandedHeader;
